// @ts-nocheck
import React, { useEffect, useState } from 'react';

const getWidth = () => (typeof window !== 'undefined' ? window.innerWidth : 0);

const Responsive = ({
  as: As = 'div',
  fireOnMount = false,
  onUpdate,
  minWidth,
  maxWidth,
  children,
  ...rest
}) => {
  const [width, setWidth] = useState(getWidth());

  useEffect(() => {
    const handle = () => {
      const w = getWidth();
      setWidth(w);
      if (onUpdate) onUpdate(null, { width: w });
    };
    window.addEventListener('resize', handle);
    if (fireOnMount && onUpdate) onUpdate(null, { width: getWidth() });
    return () => window.removeEventListener('resize', handle);
  }, [onUpdate, fireOnMount]);

  if (minWidth !== undefined && width < minWidth) return null;
  if (maxWidth !== undefined && width > maxWidth) return null;

  return <As {...rest}>{children}</As>;
};

export default Responsive;
